import React, { Component } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import axios from "axios";
import {
  Wrapper,
  FormWrapper,
  Title,
  Form,
} from "./styles/password-form-styles";
import FormStep from "./FormSteps/FormStep";
import InternetExplorerSupport from "../shared/general/InternetExplorerSupport";

class CreatePasswordForm extends Component {
  constructor(props) {
    super(props);

    const { email, firstName, lastName, phone, terms } = this.props;

    this.state = {
      step: 1,
      password: "",
      passwordConfirmation: "",
      email,
      firstName,
      lastName,
      phone,
      terms,
      errors: {},
      ieMessageActive: detect().name === "ie",
    };
  }

  componentDidMount() {
    const isIe = detect().name === "ie";

    if (isIe) {
      document.body.classList.add("internet-explorer");
    }
  }

  validate = (formData) => {
    const requestData = {
      employer_user: {
        first_name: formData.firstName,
        last_name: formData.lastName,
        mobile_number: formData.phone,
        employer_attributes: {
          name: `${formData.firstName}-${formData.lastName}`,
          agree_to_terms: formData.terms,
          phone_number: formData.phone,
        },
        email: formData.email,
        password: formData.password,
        password_confirmation: formData.passwordConfirmation,
      },
    };

    const payload = {
      url: "/employer/register",
      method: "post",
      data: requestData,
    };

    return axios(payload)
      .then(() => true)
      .catch(({ response }) => {
        this.setState({ errors: response.data.errors });
        return false;
      });
  };

  handleValidation = () => {
    const {
      password,
      passwordConfirmation,
      email,
      firstName,
      lastName,
      phone,
      terms,
    } = this.state;

    return this.validate({
      password,
      passwordConfirmation,
      email,
      firstName,
      lastName,
      phone,
      terms,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { step } = this.state;

    this.handleValidation().then((response) => {
      if (response) {
        this.setState({
          step: step + 1,
        });
      }
    });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  handleInputChange = (e) => {
    const { errors } = this.state;
    errors[e.target.name] = [""];

    this.setState({ [e.target.name]: e.target.value });
    this.setState({ errors });
  };

  closeIeMessage = () => {
    this.setState({ ieMessageActive: false });
  };

  render() {
    const { errors, step, password, passwordConfirmation, ieMessageActive } =
      this.state;
    const isIe = detect().name === "ie";

    return (
      <Wrapper isIe={isIe}>
        {ieMessageActive && (
          <InternetExplorerSupport closeIeMessage={this.closeIeMessage} />
        )}
        <FormWrapper>
          <Title className="animated fadeIn delay-2">
            {step === 2 ? "Yay!" : "Create your password"}
          </Title>
          <Form>
            <FormStep
              errors={errors}
              step={step}
              handleInputChange={this.handleInputChange}
              handleSubmit={this.handleSubmit}
              password={password}
              passwordConfirmation={passwordConfirmation}
            />
          </Form>
        </FormWrapper>
      </Wrapper>
    );
  }
}

CreatePasswordForm.propTypes = {
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  phone: PropTypes.string,
  terms: PropTypes.bool,
};

CreatePasswordForm.defaultProps = {
  email: PropTypes.isNull,
  firstName: PropTypes.isNull,
  lastName: PropTypes.isNull,
  phone: PropTypes.isNull,
  terms: PropTypes.isNull,
};

export default CreatePasswordForm;
